import { PluginSettings, ProductType, ShopType } from 'gql/__generated/vp-apollo';
import { useEffect } from 'react';
import { useCreateSession } from './useCreateSession';

export const useProvideSessionEffect = (settings: PluginSettings) => {
    const { createSession, loading, called, error } = useCreateSession();

    useEffect(() => {
        if (settings) {
            const { sellerId, productType, customerType, isYoung = false } = settings;

            createSession({
                vbIdentifier: sellerId,
                sessionContext: {
                    productType,
                    customerType,
                    ...(productType === ProductType.Fttx ? { isYoung } : {}),
                    shopType: ShopType.Webshop,
                },
            });
        }
    }, [settings, createSession]);

    return { loading, error, called };
};
